import { useTranslation } from "../../../localization/useTranslation.ts";
import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, DotLegalTableWithControls, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, TableCell, TableRow } from "@mui/material";
import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import { PaymentTermViewModel } from "./PaymentTerms.types.ts";
import usePaymentTermsHooks from "./PaymentTerms.hooks.ts";
import AddEditPaymentTermDialog from "../addEditPaymentTermDialog/AddEditPaymentTermDialog.tsx";
import { useMasterDataBreadCrumbProvider } from "../../useMasterDataBreadCrumbProvider.ts";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function ContractTypes() {
    const { translateString } = useTranslation();
    const {
        contractTypes,
        isLoading,
        getMenuItems,
        onDialogClose,
        showCreateDialog,
        onSaved,
        paymentTermForDeletion,
        setPaymentTermForDeletion,
        onDelete,
        onCreateClick,
        canManageMasterData,
        paymentTermForUpdate,
        isDeleting,
    } = usePaymentTermsHooks();

    const { getBreadCrumbs } = useMasterDataBreadCrumbProvider();

    const headers = Array<ITableHeader<PaymentTermViewModel>>();
    headers.push({ property: "name", text: translateString("name") });

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={getBreadCrumbs(translateString("paymentTerms"))}
                rightComponent={
                    canManageMasterData ? (
                        <DotLegalButton size="medium" buttonType={"primary"} onClick={() => onCreateClick()}>
                            {translateString("createPaymentTerm")}
                        </DotLegalButton>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControls
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={contractTypes}
                    emptyText={translateString("noPaymentTerms")}
                    defaultOrderBy={"name"}
                    hideRowsPerPage
                    getUserSpecificPageLength={() => 100}
                    labelRowsPerPage={translateString("showEntites")}
                    labelSearch={translateString("search")}
                    noOptionsLabel={translateString("noOptions")}
                    paginationLabelOf={translateString("labelOf")}
                    clickableRows={false}
                    hasOverflowMenu
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell align={"right"}>
                                <DotLegalOverflowMenu items={getMenuItems(row)} />
                            </TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {paymentTermForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setPaymentTermForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={paymentTermForDeletion.name}
                    inProgress={isDeleting}
                />
            )}
            {(showCreateDialog || paymentTermForUpdate !== undefined) && (
                <AddEditPaymentTermDialog
                    onDialogClose={onDialogClose}
                    isAdd={paymentTermForUpdate === undefined}
                    selectedPaymentTerm={paymentTermForUpdate}
                    onSaved={onSaved}
                />
            )}
        </Box>
    );
}

export default ContractTypes;
